import { render, staticRenderFns } from "./NewPasswordRight.vue?vue&type=template&id=c1b44f32"
import script from "./NewPasswordRight.vue?vue&type=script&lang=js"
export * from "./NewPasswordRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports